import {
  PropsWithChildren,
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";
import { EXHUT_WEB_LOCAL_STORAGE_GROUPID } from "../utils/constants";

interface IGroupContext {
  defaultGroupId?: string;
  changeDefaultGroupId: (id: string | undefined) => void;
}

export const GroupContext = createContext<IGroupContext>({
  changeDefaultGroupId: (id: string | undefined) => {},
});

export const useGroupContext = () => useContext(GroupContext);

export default function GroupProvider({ children }: PropsWithChildren<{}>) {
  const groupIdFromStorage = localStorage.getItem(
    EXHUT_WEB_LOCAL_STORAGE_GROUPID,
  );
  useEffect(() => {
    setDefaultGroupId(groupIdFromStorage || undefined);
  }, [groupIdFromStorage]);

  const [defaultGroupId, setDefaultGroupId] = useState<string | undefined>(
    undefined,
  );

  const changeGroupId = (id: string | undefined) => {
    setDefaultGroupId(id);
    localStorage.setItem(EXHUT_WEB_LOCAL_STORAGE_GROUPID, id || "");
  };

  return (
    <GroupContext.Provider
      value={{ defaultGroupId, changeDefaultGroupId: changeGroupId }}
    >
      {children}
    </GroupContext.Provider>
  );
}
